import {DetailsPageAppProps} from '../../app/interfaces'
import {connect} from '../../runtime-context/context'
import {FullDate as FullDatePresentation} from './full-date'

export interface FullDateProps extends FullDateRuntimeProps {}

export interface FullDateRuntimeProps {
  event: ExtendedEvent
}

const mapRuntime = ({state}: DetailsPageAppProps): FullDateRuntimeProps => ({
  event: state.event,
})

export const FullDate = connect<{}, FullDateRuntimeProps>(mapRuntime)(FullDatePresentation)
